exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".label-ohif {\n  font-size: 1em;\n  color: #ffffff;\n}\n\n.label-example {\n  background-color: var(--ui-gray-darker);\n}\n", ""]);
